import TPORequests from 'modules/TPORequests/index'
import { connect } from 'react-redux'

import {
  getConsentDrawerList,
  getTPOFilter,
  getTPOMetrics,
  getTpoUserList,
  updateAllRequestList,
} from 'modules/TPORequests/actions'
import selectors from 'modules/TPORequests/selectors'
import { getPreview } from '../../ATS/action'
import {
  getJobRolePreview,
  getPlacementHistoryList,
  getStudentPlacedList,
} from '../../JobPreview/action'

const mapStateToProps = state => ({
  tpoMetrics: selectors?.getTpoMetricsData(state),
  tpoUserListData: selectors?.getTpoUserListData(state),
})

const mapDispatchToProps = {
  getTPOMetrics,
  getTpoUserList,
  updateAllRequestList,
  getConsentDrawerList,
  getTPOFilter,
  getPreview,
  getJobRolePreview,
  getStudentPlacedList,
  getPlacementHistoryList,
}

export default connect(mapStateToProps, mapDispatchToProps)(TPORequests)
